/* eslint-disable array-callback-return */
import React, { useEffect, useState } from 'react';
import { Button, Icon, Modal, Spin, Upload } from "antd";
import ImgCrop from 'antd-img-crop';
import nanoid from 'nanoid'
import selectImag from '@/assets/teacherCare/select.png'
import useUploadOss from '../../../../../hooks/useUploadOss';
import styles from './index.less';

const SelectFrontCover = (props) => {
  const { onCoverListChange, personRule, personRule: coverInfoProps, form, onChange } = props;
  const { coverConfigList } = personRule || {}
  const [coverInfo, setInfo] = useState(coverInfoProps);
  const [visible, setVisible] = useState(false);
  const [selectedCover, setSelectedCover] = useState(
    coverConfigList
  );
  const uniImg = nanoid()
  const { upload, loading } = useUploadOss({
    options: {
      prefix: `push_cover_${uniImg}`,
      onOk: (uploadUrl) => {
        coverConfigList.unshift({
          coverUrl: uploadUrl,
          wthrChoose: '1'
        })
        onCoverListChange([...coverConfigList]);
        setSelectedCover({
          coverConfigList
        })
      },
    },

  },
  );

  useEffect(() => {
    setInfo(coverInfoProps);
    setSelectedCover(coverInfoProps);
  }, [coverInfoProps])

  const onFileChange = () => {
    // console.log('onChange', file)
    // setFileList(newFileList);
  };

  const handleOnOk = () => {
    if (onChange) {
      onChange(selectedCover.coverConfigList);
    }
    setVisible(false);
  };

  const handleCancel = () => {
    setVisible(false);
    setSelectedCover({ ...coverInfo })
  };

  // 修改modal可见状态
  const handleVisibleChange = (status) => {
    setVisible(status);
  };

  // 选中已有封面
  const handleCoverSelected = (id, wthrChoose) => {
    (coverConfigList || []).map((el) => {
      if (el.id === id) {
        // eslint-disable-next-line no-param-reassign
        el.wthrChoose = wthrChoose === '1' ? '0' : '1'
      }
    })
    setSelectedCover({ coverConfigList })
  };

  const handleUploadCover = (file) => {
    upload(file.file)
  };

  const { getFieldValue } = form;
  const mCoverInfo = getFieldValue('coverInfo');
  const selectCover = (((coverConfigList || [])[(coverConfigList || []).map(o => o.wthrChoose).indexOf('1')]) || {}).coverUrl
  return (
    <div className={styles.root}>
      {/* 选择按钮 */}
      <div className='btn-container'>
        <Button
          onClick={() => handleVisibleChange(true)}
        >
          {mCoverInfo && mCoverInfo.coverUrl ? '修改' : '选择'}
        </Button>

      </div>

      {/* 渲染已选中的封面 */}
      <div className='checked-item'>
        <div
          className='item-img'
          style={{
            backgroundImage: `url(${selectCover})`
          }}
        />
      </div>

      <Modal
        width={680}
        className='cover-modal'
        title='推送封面'
        visible={visible}
        onCancel={handleCancel}
        onOk={handleOnOk}
        cancelText='取消'
        okButtonProps={{ disabled: !selectCover }}
        okText='确定'
      >
        <Spin spinning={loading}>
          <div className='cover-list'>
            <div
              className='cover-item un-checked'
            >
              <ImgCrop
                aspect={75 / 32}
                rotate={false}
              >
                <Upload
                  customRequest={handleUploadCover}
                  listType="picture-card"
                  fileList={[]}
                  onChange={onFileChange}
                >
                  <Icon type='plus' />
                </Upload>
              </ImgCrop>
            </div>
            {(coverConfigList || []).map(({ wthrChoose, id, coverUrl }) => {
              const coverItem = (wthrChoose === '1') ? 'checked' : 'un-checked'
              return (
                <div
                  className={`cover-item ${coverItem}`}
                  key={coverUrl}
                  onClick={() => handleCoverSelected(id, wthrChoose)}
                >
                  <img src={selectImag} className={`selectImag ${coverItem}`} alt="" />
                  <div className={`img ${coverItem}`}>
                    <img alt="" src={coverUrl} />
                  </div>
                </div>
              )
            })}
          </div>
        </Spin>
      </Modal>
    </div>
  );
}

export default SelectFrontCover;
